export default{
    currency:'currency',
    currencyTitle: 'Currency Title',
    currencyStatus: 'Currency Status',
    currencies:'Currencies',
    editCurrency:'Edit Currency',
    addCurrency:'Add Currency',
}